module.exports = __webpack_public_path__ + "static/Veneers 2 intraoral before-67354fc7951f7823ba949caa7f7483fe.jpg";